import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import WikiContents from "./WikiContents";
import { wikiTopicPages, wikiTopicSources } from "./wikiTopicPages";
import "./Wiki.css";

const ref = (id) => (
  <sup className="wiki-ref" key={id}>
    <a href={`#${id}`}>{id.replace("r", "")}</a>
  </sup>
);

const refs = (ids) => ids.map((id) => ref(id));

const WikiTopicPage = () => {
  const { slug } = useParams();
  const page = wikiTopicPages[slug];

  if (!page) return <Navigate to="/research" replace />;

  return (
    <main className="wiki-page">
      <WikiContents
        backLink={{ href: "/research", label: "Research Trajectory" }}
        sections={page.contents}
      />

      <article className="wiki-article">
        <h1>{page.title}</h1>

        <section id="overview">
          <p className="wiki-lead">{page.lead}</p>
        </section>

        {page.sections.map((section) => (
          <section id={section.id} key={section.id}>
            <h2>{section.title}</h2>
            <p>
              {section.body} {refs(section.refs)}
            </p>
            {section.links && (
              <p className="wiki-related-links">
                Related:{" "}
                {section.links.map((link, index) => (
                  <React.Fragment key={link.href}>
                    {index > 0 ? ", " : ""}
                    <Link to={link.href}>{link.label}</Link>
                  </React.Fragment>
                ))}
              </p>
            )}
          </section>
        ))}

        <section id="references">
          <div className="wiki-reference-head">
            <h2>References</h2>
            <Link to="/research">Back to trajectory</Link>
          </div>
          <ol className="wiki-references">
            {page.references.map((sourceId) => {
              const source = wikiTopicSources[sourceId];
              return (
                <li id={sourceId} key={sourceId}>
                  {source.href ? (
                    <a href={source.href} target="_blank" rel="noreferrer">
                      {source.label}. <em>{source.title}</em>.
                    </a>
                  ) : (
                    <>
                      {source.label}. <em>{source.title}</em>.
                    </>
                  )}
                </li>
              );
            })}
          </ol>
        </section>
      </article>
    </main>
  );
};

export default WikiTopicPage;
